/**
 * @fileoverview gRPC-Web generated client stub for providers_api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v6.31.1
// source: providers.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as messages_providers_message_pb from './messages/providers.message_pb'; // proto import: "messages/providers.message.proto"


export class ProvidersServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorSearch = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/Search',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersSearchRequest,
    messages_providers_message_pb.ProvidersSearchResponse,
    (request: messages_providers_message_pb.ProvidersSearchRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersSearchResponse.deserializeBinary
  );

  search(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersSearchResponse>;

  search(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersSearchResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersSearchResponse>;

  search(
    request: messages_providers_message_pb.ProvidersSearchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersSearchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/Search',
        request,
        metadata || {},
        this.methodDescriptorSearch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/Search',
    request,
    metadata || {},
    this.methodDescriptorSearch);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/Get',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetRequest,
    messages_providers_message_pb.ProvidersGetResponse,
    (request: messages_providers_message_pb.ProvidersGetRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetResponse.deserializeBinary
  );

  get(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetResponse>;

  get(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetResponse>;

  get(
    request: messages_providers_message_pb.ProvidersGetRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorGetBillingLimits = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/GetBillingLimits',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetBillingLimitsRequest,
    messages_providers_message_pb.ProvidersGetBillingLimitsResponse,
    (request: messages_providers_message_pb.ProvidersGetBillingLimitsRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetBillingLimitsResponse.deserializeBinary
  );

  getBillingLimits(
    request: messages_providers_message_pb.ProvidersGetBillingLimitsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetBillingLimitsResponse>;

  getBillingLimits(
    request: messages_providers_message_pb.ProvidersGetBillingLimitsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetBillingLimitsResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetBillingLimitsResponse>;

  getBillingLimits(
    request: messages_providers_message_pb.ProvidersGetBillingLimitsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetBillingLimitsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/GetBillingLimits',
        request,
        metadata || {},
        this.methodDescriptorGetBillingLimits,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/GetBillingLimits',
    request,
    metadata || {},
    this.methodDescriptorGetBillingLimits);
  }

  methodDescriptorGetProviderNotificationPreferencesByUserId = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/GetProviderNotificationPreferencesByUserId',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse,
    (request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse.deserializeBinary
  );

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse>;

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse>;

  getProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/GetProviderNotificationPreferencesByUserId',
        request,
        metadata || {},
        this.methodDescriptorGetProviderNotificationPreferencesByUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/GetProviderNotificationPreferencesByUserId',
    request,
    metadata || {},
    this.methodDescriptorGetProviderNotificationPreferencesByUserId);
  }

  methodDescriptorUpdateProviderNotificationPreferencesByUserId = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/UpdateProviderNotificationPreferencesByUserId',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse,
    (request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse.deserializeBinary
  );

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse>;

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse>;

  updateProviderNotificationPreferencesByUserId(
    request: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersUpdateNotificationPreferencesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/UpdateProviderNotificationPreferencesByUserId',
        request,
        metadata || {},
        this.methodDescriptorUpdateProviderNotificationPreferencesByUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/UpdateProviderNotificationPreferencesByUserId',
    request,
    metadata || {},
    this.methodDescriptorUpdateProviderNotificationPreferencesByUserId);
  }

  methodDescriptorGetProviderNotificationPreferencesByExternalUserId = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/GetProviderNotificationPreferencesByExternalUserId',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdRequest,
    messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse,
    (request: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse.deserializeBinary
  );

  getProviderNotificationPreferencesByExternalUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse>;

  getProviderNotificationPreferencesByExternalUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse>;

  getProviderNotificationPreferencesByExternalUserId(
    request: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProvidersGetNotificationPreferencesByExternalUserIdResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/GetProviderNotificationPreferencesByExternalUserId',
        request,
        metadata || {},
        this.methodDescriptorGetProviderNotificationPreferencesByExternalUserId,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/GetProviderNotificationPreferencesByExternalUserId',
    request,
    metadata || {},
    this.methodDescriptorGetProviderNotificationPreferencesByExternalUserId);
  }

  methodDescriptorCreateActivity = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/CreateActivity',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.ProviderCreateActivityRequest,
    messages_providers_message_pb.ProviderCreateActivityResponse,
    (request: messages_providers_message_pb.ProviderCreateActivityRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.ProviderCreateActivityResponse.deserializeBinary
  );

  createActivity(
    request: messages_providers_message_pb.ProviderCreateActivityRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.ProviderCreateActivityResponse>;

  createActivity(
    request: messages_providers_message_pb.ProviderCreateActivityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProviderCreateActivityResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.ProviderCreateActivityResponse>;

  createActivity(
    request: messages_providers_message_pb.ProviderCreateActivityRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.ProviderCreateActivityResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/CreateActivity',
        request,
        metadata || {},
        this.methodDescriptorCreateActivity,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/CreateActivity',
    request,
    metadata || {},
    this.methodDescriptorCreateActivity);
  }

  methodDescriptorGetProviderRates = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/GetProviderRates',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.GetProviderRatesRequest,
    messages_providers_message_pb.GetProviderRatesResponse,
    (request: messages_providers_message_pb.GetProviderRatesRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.GetProviderRatesResponse.deserializeBinary
  );

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.GetProviderRatesResponse>;

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.GetProviderRatesResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.GetProviderRatesResponse>;

  getProviderRates(
    request: messages_providers_message_pb.GetProviderRatesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.GetProviderRatesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/GetProviderRates',
        request,
        metadata || {},
        this.methodDescriptorGetProviderRates,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/GetProviderRates',
    request,
    metadata || {},
    this.methodDescriptorGetProviderRates);
  }

  methodDescriptorUpsertProviderRate = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/UpsertProviderRate',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.UpsertProviderRateRequest,
    messages_providers_message_pb.UpsertProviderRateResponse,
    (request: messages_providers_message_pb.UpsertProviderRateRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.UpsertProviderRateResponse.deserializeBinary
  );

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.UpsertProviderRateResponse>;

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.UpsertProviderRateResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.UpsertProviderRateResponse>;

  upsertProviderRate(
    request: messages_providers_message_pb.UpsertProviderRateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.UpsertProviderRateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/UpsertProviderRate',
        request,
        metadata || {},
        this.methodDescriptorUpsertProviderRate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/UpsertProviderRate',
    request,
    metadata || {},
    this.methodDescriptorUpsertProviderRate);
  }

  methodDescriptorDeleteProviderRate = new grpcWeb.MethodDescriptor(
    '/providers_api.ProvidersService/DeleteProviderRate',
    grpcWeb.MethodType.UNARY,
    messages_providers_message_pb.DeleteProviderRateRequest,
    messages_providers_message_pb.DeleteProviderRateResponse,
    (request: messages_providers_message_pb.DeleteProviderRateRequest) => {
      return request.serializeBinary();
    },
    messages_providers_message_pb.DeleteProviderRateResponse.deserializeBinary
  );

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata?: grpcWeb.Metadata | null): Promise<messages_providers_message_pb.DeleteProviderRateResponse>;

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.DeleteProviderRateResponse) => void): grpcWeb.ClientReadableStream<messages_providers_message_pb.DeleteProviderRateResponse>;

  deleteProviderRate(
    request: messages_providers_message_pb.DeleteProviderRateRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: messages_providers_message_pb.DeleteProviderRateResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/providers_api.ProvidersService/DeleteProviderRate',
        request,
        metadata || {},
        this.methodDescriptorDeleteProviderRate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/providers_api.ProvidersService/DeleteProviderRate',
    request,
    metadata || {},
    this.methodDescriptorDeleteProviderRate);
  }

}

